import React, { useEffect, forwardRef } from 'react';
import classnames from 'classnames';

import "./actionprompt.scss";

const ActionPrompt = forwardRef(({desktop = false, follow = false, classes = '', children}, ref) => {

	function detectFooter () {
		const footerElement = document.getElementsByTagName('footer')[0];
		if(!footerElement) return;

		if (window.innerHeight - footerElement.getBoundingClientRect().top >= 0) {
			ref.current.style.bottom = `${(window.innerHeight - footerElement.getBoundingClientRect().top)}px`;
		} else if (window.innerHeight - footerElement.getBoundingClientRect().top < 0) {
			ref.current.style.bottom = 0;
		}
	}

	useEffect(() => {
		if(window.innerWidth <= 768 || desktop) window.addEventListener("scroll", detectFooter, true);
        return () => { window.removeEventListener("scroll", detectFooter, true); }
	}, [])

	return (
		<div
			ref={ref}
			className={classnames([
				"action-prompt action-prompt--bottom mt-4",
				{'action-prompt--follow': follow},
				classes
			])}
		>
			<div className="container">
				{children}
			</div>
		</div>
	)
})

export default ActionPrompt;